export const environment = {
  production: false,
  apiPath: 'https://app-03-601-01.azurewebsites.net/api/v1/',
  // apiPath: 'http://localhost:5120/api/v1/',
  // datatransPath: 'https://pay.sandbox.datatrans.com/v1/start/',
  // googleAPiKey: 'AIzaSyBo3HXg0Sr73xnTOxZJEmmOkM08KO0JDtM',
  motrackingUrl: 'https://login.motracking.ch/api/v1/unit/list.json',
  motrackingKey: '39c4bd4dab75642c1e0168931dfed3185ca2e623',
  mulesoftApi: 'https://cotra-client-eapi-v1-dev-gooxz5.x3v5w.deu-c1.eu1.cloudhub.io/api/v1/',
  translationVersion: 55,
};